// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ViewRef, ElementRef, HostListener, Injectable, Input } from '@angular/core';

//Models
@Component({
	selector: 'kt-print-template',
	templateUrl: './print-template.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})


export class PrintTemplateComponent implements OnInit {
	@Input() loaiPhieu: any;
	@Input() masterData: any;
	@Input() detailData: any[];

	// .. Khai báo constant
	//Kho
	MAUIN_DNXK_XNB 	= 'PDNXKNB_171123';
	MAUIN_DNXK_XBH 	= 'PDNXKBH_171123';
	MAUIN_XK_XNB 	= 'PXK_171123_NB';
	MAUIN_XK_XBH 	= 'PXK_171123_BH';
	MAUIN_XK_TRANCC = 'PXK_171123_TRANCC';
	MAUIN_XK_XKH 	= 'PXK_171123_XUATKH';
	//KD
	MAUIN_DTH 		= 'PDTH';
	//Mua hang
	MAUIN_PDNMHTYC 	= 'PDNMHTNC';
	constructor(
		private changeDetect: ChangeDetectorRef,
		) {}
	/**
	 * On init
	 */
	ngOnInit() {
		console.log(this.masterData, this.loaiPhieu, this.detailData);
	}
	// .. Change DOM
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}
}
